<template>
    <div class="col-12">

        <h6 class="q-mb-none">{{$T('lending kits')}}</h6>
        <v-autocomplete
                ref="deviceInput"
                v-if="'Pending' === form['stock_order_status.description'] || ('In Transit' === form['stock_order_status.description'] && 'Recolher' === form['stock_operation.description']) && 'Retail Call Center' != user.role.name"
                path="lending_kit_id"
                :resource-path="operationResourcePath"
                key="lending_kit_id"
                v-model="lending_kit"
                :top="0"
                :label="$t('add a new one')+' '+$t('lending kit')"
                :item-plural="$t('lending kits')"
                :map="item => ({
                                label: `${item.codentify}`,
                                value: item,
                                sublabel: `${this.$T('codentify')}: ${item.codentify}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
                            })"
                :form="form"
                @input="selectDevice"
                class="col-xl-3 col-md-4 col-sm-6 col-xs-12 q-mt-sm q-mb-md"
                field-icon="fa fa-barcode">
        </v-autocomplete>


            <q-table class="shadow-25 v-list bg-white"
                     style="width:90vw; max-width: 100%;max-height: 400px"
                     :data.sync="devicesList"
                     :columns="columns"
                     row-key="id">
                <q-tr slot="header" slot-scope="props" :props="props">
                    <q-th v-for="col in props.cols" :key="col.name" :props="props" v-if="canDelete(col)">
                        <template>
                            {{ $t(col.label) }}
                        </template>
                    </q-th>
                </q-tr>
                <q-tr slot="body" slot-scope="props" :props="props"  class="cursor-pointer">
                    <q-td v-for="col in props.cols" :key="col.name" :props="props" v-if="canDelete(col)">
                        <template v-if="col.name==='actionDelete'">
                            <v-button @click.native="deleteItem(col.value)" color="negative" round rounded icon="delete">
                                <q-tooltip> {{$T('delete')}}</q-tooltip>
                            </v-button>
                        </template>
                        <img height="100px" v-if="col.name == 'image' && col.value" :src="`/storage/uploads/${col.value}`" />
                        <template v-else>
                            {{ col.value }}
                        </template>
                    </q-td>
                </q-tr>

            </q-table>

    </div>

</template>

<script>
    import VInput from "../../../components/form/VInput";
    import VAutocompleteList from "../../../components/form/VAutocompleteList";
    import VHeader from "../../../components/Header";
    import VButton from "../../../components/form/VButton";
    import Dialog from 'quasar-framework'
    import axios from "axios";
    import {mapGetters} from "vuex";
    export default {
        name: "devices-input",
        components: {VButton, VHeader, VAutocompleteList, VInput, Dialog},
        props:[
            'form',
        ],
        data() {
            return {
                devicesList: [],
                stockOrderId: this.form.id,
                lending_kit: null,
                columns:  [
                    {
                        name: 'identifier',
                        label: this.$T('identifier'),
                        field: 'identifier',
                        align:  'left',
                        sortable: false,
                        required: false
                    },
                    {
                        name: 'codentify',
                        label: this.$T('codentify'),
                        field: 'codentify',
                        align:  'left',
                        sortable: false,
                        required: false
                    },
                    {
                        name: 'model',
                        label: this.$T('model'),
                        field: 'model',
                        align:  'left',
                        sortable: false,
                        required: false
                    },
                    {
                        name: 'sku_code',
                        label: this.$T('sku code'),
                        field: 'sku_code',
                        align:  'left',
                        sortable: false,
                        required: false
                    },
                    {
                        name: 'sku_description',
                        label: this.$T('sku description'),
                        field: 'sku_description',
                        align:  'left',
                        sortable: false,
                        required: false
                    },
                    {
                        name: 'image',
                        label: this.$T('image'),
                        field: 'image',
                        align:  'left',
                        sortable: false,
                        required: false
                    },
                    {
                        name: 'actionDelete',
                        label: this.$T('delete'),
                        field: 'id',
                        align:  'left',
                        sortable: false,
                        required: false
                    },
                ]
            }
        },
        methods: {
           async selectDevice(device) {
                if(device && !this.devicesList.find( (item) => item.id === device.id) )
                {
                    const {data} = await axios.post(`${config.appUrl}/api/v1/courier/stock-orders/register/lending-kit/${this.form.id}`, {device})
                    this.devicesList.unshift(device)
                    this.form.devices = this.devicesList
                }
                this.lending_kit = null
                // this.$nextTick(() => {
                //     this.$refs.deviceInput.$refs.field.$el.click()
                // });
            },

            async deleteItem(id) {
              this.$q.dialog({
                title: this.$T('are you sure?'),
                preventClose: true,
                color: 'primary',
                stackButtons: true,
                ok: {
                  label: `${this.$T('Ok')}`,
                },
                cancel: {
                  color: 'negative',
                  label: this.$T('Cancel'),
                }
              }).then( async () => {
                const {data} = await axios.post(`${config.appUrl}/api/v1/courier/stock-orders/remove/lending-kit/${this.form.id}`, {device: {id: id}})
                let deleteIndex = this.devicesList.findIndex((item) => item.id == id)
                this.devicesList.splice(deleteIndex, 1)
              }).catch(() => {});
            },

            getOrderDevices(orderId) {
               axios.get(`${config.appUrl}/api/v1/courier/stock-orders/lending-kits/${this.form.id}`).then(({data}) =>{
                   this.devicesList = data.map(el => {
                        if(el.lending_kit_color) {
                            el.model = el.lending_kit_color.lending_kit_model.description
                            el.sku_code = el.lending_kit_color.sku
                            el.sku_description = el.lending_kit_color.description
                            el.image = el.lending_kit_color.image
                        }
                        return el;
                   })
                   this.form.devices = data;
               } )
            },
            canDelete(col) {
               if(col.name ==='actionDelete') {

                   if ( ('Pending' === this.form['stock_order_status.description']) ||
                       ('In Transit' === this.form['stock_order_status.description']) && 'Recolher' === this.form['stock_operation.description'] && 'Retail Call Center' != this.user.role.name)  {
                       return true
                   } else {
                       return false;
                   }
               }

               return true;
            },
        },
        computed: {
          ...mapGetters({
            user: 'auth/user'
          }),
            operationResourcePath() {
                return ('Recolher' === this.form['stock_operation.description']) ? `v1/lending-kits-to-collect`:`v1/my-available-lending-kits`
            }
        },
        watch: {
            'form.id' : {
                // the callback will be called immediately after the start of the observation
                immediate: true,
                handler (val, oldVal) {
                    this.deviceList = [];
                    this.getOrderDevices(val)
                }

            }
        }


    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/courier/stock-order/DevicesInput.vue